export const USER_FIELDS = Object.freeze({
  NAME: 'firstName',
  LAST_NAME: 'lastName'
});
